// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__aisL6","requiredAsterisk":"Info_requiredAsterisk__1-dYB"};